// ----------------------------------------------------------------------

function pxToRem(value) {
  return `${value / 16}rem`;
}

const FONT_PRIMARY = 'Public Sans, sans-serif';

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: 76 / 60,
    fontSize: pxToRem(34),
  },
  h2: {
    fontWeight: 700,
    lineHeight: 60 / 44,
    fontSize: pxToRem(28),
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(21),
  },
  h4: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
  },
  h5: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  h6: {
    fontWeight: 700,
    lineHeight: 26 / 16,
    fontSize: pxToRem(15),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 20 / 13,
    fontSize: pxToRem(13),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  body2: {
    lineHeight: 20 / 13,
    fontSize: pxToRem(13),
  },
  caption: {
    lineHeight: 1.4,
    fontSize: pxToRem(11),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.4,
    fontSize: pxToRem(11),
    letterSpacing: 1.1,
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 700,
    lineHeight: 22 / 13,
    fontSize: pxToRem(13),
    textTransform: 'capitalize',
  },
};

export default typography;
